export default __webpack_public_path__ + "static/va-6d6a5ae672030a7e351ffa3265e44c32.svg";